<template>
  <div class="relative flex flex-col">
    <div v-if="unit" class="grid flex-1 w-full grid-cols-2 gap-12 p-12 xl:gap-16 xl:p-16">
      <div class="relative flex items-center justify-end">
        <div class="flex justify-end w-80 h-72 xl:w-full xl:h-112">
          <unit-image :name="unit.name" :rotate="0" class="flex items-center justify-end" />
        </div>
      </div>
      <div class="flex flex-col justify-center">
        <div class="mb-8">
          <h1 class="text-3xl font-bold uppercase xl:text-4xl text-primary-500">
            TYPE {{ unit.name }}
          </h1>
          <p class="text-xl uppercase xl:text-2xl">
            {{ unitType.name }}
          </p>
          <p class="xl:text-lg">
            {{ unit.area }} sqm
          </p>
        </div>
      </div>
    </div>

    <unit-list :items="units" :selected="[unit]" :slide-to="slideTo" @select="onSelect" />

    <div class="flex flex-no-wrap flex-shrink-0 py-4 mx-auto space-x-4 overflow-x-auto whitespace-no-wrap fhd:max-w-none">
      <label v-for="type in collections.unitTypes" :key="type.id" class="cursor-pointer">
        <input v-model="selectedType" type="radio" :value="type.id" class="hidden">
        <div class="relative px-3 py-1 transition-all duration-300">
          {{ type.name }}
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import UnitImage from '@/components/UnitImage.vue'
import UnitList from '@/components/UnitList.vue'

export default {
  name: 'Units',
  components: {
    UnitImage,
    UnitList,
  },
  props: {
    unitName: {
      type: String,
      require: false,
      default: 'A1',
    },
  },
  data () {
    return {
      collections: {
        units: require('@/assets/data/units.json'),
        unitTypes: require('@/assets/data/unit_types.json'),
      },

      selectedType: 1,
      slideTo: 0,
    }
  },
  computed: {
    units () {
      return this.collections.units.filter(({ typeId }) => typeId === this.selectedType)
    },
    unit () {
      return this.collections.units.find(({ name }) => name === this.unitName) || {}
    },
    unitType () {
      return this.collections.unitTypes.find(({ id }) => id === this.unit.typeId) || {}
    },
  },
  activated () {
    this.setSlideToIndex()
  },
  mounted () {
    if (!this.$route.params.floorId) {
      this.$route.params.floorId = 6
    }
  },
  methods: {
    onSelect (item) {
      this.$router.replace({
        name: 'MasterPlansUnits',
        params: {
          unitName: item.name,
        },
        query: {
          floorId: this.$route.query.floorId,
          unitName: item.name || this.$route.query.unitName,
        },
      })
    },
    setSlideToIndex () {
      this.selectedType = this.unit.typeId
      this.slideTo = this.units.findIndex(unit => unit.name === this.unitName)
    },
  },
}
</script>

<style lang="postcss" scoped>
input[type="radio"]:checked + div {
  @apply text-white bg-black shadow rounded-full;
}
.medium-zoom-image {
  @apply object-center;
}

::v-deep(.swiper-slide) {
  touch-action: none;
}
</style>
